<template>
  <div class="hub modals">
    <SelectCustomerModal />
    <CreateStaffModal />
    <CreateCustomerModal />
    <CreateProjectModal />
  </div>
</template>

<script>
import { CreateCustomerModal, CreateStaffModal, CreateProjectModal, SelectCustomerModal } from './'
export default {
  components: {
    CreateCustomerModal,
    CreateStaffModal,
    CreateProjectModal,
    SelectCustomerModal,
  },
}
</script>

<style lang="scss" scoped></style>
